import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Api } from "../../../BackendApi/api";
import "../MobileCustomerOverlay.css";
import MobileConfirmPopup from "../../../Component/MobileConfirmPopup/MobileConfirmPopup";
import MobileCoinAllotmentOverlay from "../../MobileCoinsAllotments/MobileCoinAllotmentOverlay";

const EditMobileCustomerOverlay = ({ customer, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    custName: "",
    Custmobile: "",
    address: "",
    reference: "",
    location: "",
    status: "ACTIVE",
  });

  const [loading, setLoading] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const [showCoinOverlay, setShowCoinOverlay] = useState(false);
  const nameInputRef = useRef(null);

  useEffect(() => {
    if (customer) {
      setFormData({
        custName: customer.customerName || "",
        Custmobile: customer.mobile || "",
        address: customer.address || "",
        location: customer.mapLocation
          ? `${customer.mapLocation.lat}, ${customer.mapLocation.lng}`
          : "",
        reference: customer.reference || "",
        status: customer.status === "ACTIVE" ? "ACTIVE" : "DEACTIVE",
      });
    }
    if (nameInputRef.current) {
      nameInputRef.current.focus();
    }
  }, [customer]);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!customer || !customer.id) {
      alert("❌ Customer ID is missing!");
      return;
    }

    if (!formData.location || !formData.location.includes(",")) {
      setPopup({
        show: true,
        message: "Please enter valid location in 'lat,lng' format!",
        type: "warning",
      });
      return;
    }

    const [lat, lng] = formData.location.split(",").map(Number);
    if (isNaN(lat) || isNaN(lng)) {
      setPopup({
        show: true,
        message: "Invalid latitude or longitude!",
        type: "warning",
      });
      return;
    }

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setPopup({
          show: true,
          message: "Please login first!",
          type: "warning",
        });
        return;
      }

      setLoading(true);

      const payload = {
        _id: customer.id,
        CustName: formData.custName,
        CustMobile: formData.Custmobile,
        CustAddress: formData.address,
        CustLocation: formData.location,
        Reference: formData.reference,
        Status: formData.status === "ACTIVE" ? "ACTIVE" : "DEACTIVE",
      };

      const res = await axios.post(Api.editCustomer, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.status === 200 && res.data?.status !== 0) {
        setPopup({
          show: true,
          message: res.data.message || "Customer updated successfully!",
          type: "success",
        });
      } else {
        setPopup({
          show: true,
          message: "Failed to update customer",
          type: "error",
        });
      }
    } catch (error) {
      setPopup({
        show: true,
        message: error.response?.data?.message || "Failed to update customer",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
    if (popup.type === "success") {
      if (onSave) onSave();
      onClose();
    }
  };

  return (
    <>
      <div
        className={`mobile-overlay ${showCoinOverlay ? "blur-background" : ""}`}
      >
        <div className="mobile-overlay-content">
          <h2>Edit Customer</h2>
          <form className="mobile-overlay-form" onSubmit={handleSubmit}>
            <label className="custname-label">
              Customer Name
              <div className="custname-column">
                <input
                  ref={nameInputRef}
                  type="text"
                  name="custName"
                  value={formData.custName}
                  onChange={handleChange}
                  required
                />
                <button
                  type="button"
                  className="add-btn-below"
                  onClick={() => setShowCoinOverlay(true)}
                >
                  + Add Coins
                </button>
              </div>
            </label>

            <label>
              Mobile
              <input
                type="text"
                name="Custmobile"
                value={formData.Custmobile}
                onChange={handleChange}
                required
              />
            </label>

            <label>
              Address
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </label>

            <label>
              Location
              <input
                type="text"
                name="location"
                value={formData.location}
                onChange={handleChange}
              />
            </label>

            <label>
              Reference
              <input
                type="text"
                name="reference"
                value={formData.reference}
                onChange={handleChange}
              />
            </label>

            <label>
              Status
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
              >
                <option value="ACTIVE">Active</option>
                <option value="DEACTIVE">DeActive</option>
              </select>
            </label>

            <div className="mobile-overlay-buttons full-width">
              <button type="button" onClick={onClose} disabled={loading}>
                Cancel
              </button>
              <button type="submit" disabled={loading}>
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </form>
        </div>

        <MobileConfirmPopup
          show={popup.show}
          message={popup.message}
          type={popup.type}
          onClose={handlePopupClose}
        />
      </div>

      {/* ✅ Pass customer details to Coin Overlay */}
      {showCoinOverlay && (
        <MobileCoinAllotmentOverlay
          onClose={() => setShowCoinOverlay(false)}
          customer={{
            id: customer?.id,
            name: formData.custName,
            mobile: formData.Custmobile,
          }}
        />
      )}
    </>
  );
};

export default EditMobileCustomerOverlay;
